import React from 'react'
import Button from './Button'

import {useMutation} from 'hooks'
import {mutationRemoveParticipator} from 'graph'

/**
 * Removes a participation. The same mutation serves the author (removing any
 * participant) and a participant removing themselves (leaving) — the backend
 * authorizes both. `leave` only changes the label/variant.
 */
export default function RemoveParticipatorButton({participation, adventure, leave = false, ...props}: any)
{
	const [remove, {loading}] = useMutation(mutationRemoveParticipator, {
		variables: {input: {id: participation.id}},
		update(cache: any) {
			cache.modify({
				id: cache.identify(adventure),
				fields: {
					participations(existing: any = {edges: [], pagination: {}}, {readField}: any) {
						const edges = (existing.edges ?? []).filter(
							(e: any) => readField('id', e) !== participation.id
						)
						return {
							...existing,
							pagination: {
								...existing.pagination,
								total: Math.max((existing.pagination?.total ?? 1) - 1, 0),
							},
							edges,
						}
					},
				},
			})
		},
		onError(error: any) { console.log(error) },
	})

	return (
		<Button
			variant={leave ? 'outline-secondary' : 'outline-danger'}
			disabled={loading}
			onClick={() => remove()}
			{...props}
		>
			{leave ? 'Leave' : 'Remove'}
		</Button>
	)
}
